export const PAYLOAD_STATUS = "payload";
export const SURVEY_STATUS = "survey";
export const QUESTIONNAIRE_STATUS = "questionnaire";

export const STATUS_PENDING = "pending";
export const STATUS_OK = "ok";
export const STATUS_ERROR = "error";
export const STATUS_COMPLETED = "completed";
